import React from "react";
import "../logo.css";

const Logo = ({ size = "md", className = "" }) => {
  return (
    <img
      src="/logo.png"
      alt="Fiji Planner ERP Logo"
      // This combines our custom class, the size class, and any extra classes you pass
      className={`app-logo logo-${size} ${className}`}
    />
  );
};

export default Logo;
